@if (group().NestedGroup) {
  <section class="checkboxgroup-section users-group-selection">
    <mat-accordion>
      <mat-expansion-panel [expanded]="true" hideToggle #togglearrow>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <span class="mat-expansion-list-section">
              <mat-checkbox
                class="mat-expansion-checkbox"
                (click)="$event.stopPropagation()"
                [checked]="allComplete()"
                [color]="'primary'"
                [indeterminate]="someComplete()"
                (change)="setAll($event.checked); getText()"
                >
                {{ group().value }}
              </mat-checkbox>
              @if (!togglearrow.expanded) {
                <mat-icon
                  class="check-mat-arrow"
                  color="primary"
                  fontIcon="arrow_drop_down"
                ></mat-icon>
              }
              @if (togglearrow.expanded) {
                <mat-icon
                  class="check-mat-arrow"
                  color="primary"
                  fontIcon="arrow_drop_up"
                ></mat-icon>
              }
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <span class="checkboxgroup-list-section">
          <ul>
            @for (subgroup of group().NestedGroup; track subgroup) {
              <li>
                <mat-checkbox
                  [(ngModel)]="subgroup.completed"
                  [color]="'primary'"
                  (ngModelChange)="updateAllComplete(); getText()"
                  >
                  {{ subgroup.value }}
                </mat-checkbox>
              </li>
            }
          </ul>
        </span>
      </mat-expansion-panel>
    </mat-accordion>
  </section>
}

@if (!group().NestedGroup) {
  <section class="checkboxgroup-section users-group-selection">
    <span class="mat-expansion-list-section">
      <mat-checkbox
        class="example-margin"
        [checked]="allComplete()"
        [color]="'primary'"
        [indeterminate]="someComplete()"
        (change)="setAll($event.checked); getText()"
        >
        {{ group().value }}
      </mat-checkbox>
    </span>
    <span class="checkboxgroup-list-section">
      <ul>
        @for (subgroup of group().NestedGroup; track subgroup) {
          <li>
            <mat-checkbox
              [(ngModel)]="subgroup.completed"
              [color]="'primary'"
              (ngModelChange)="updateAllComplete(); getText()"
              >
              {{ subgroup.value }}
            </mat-checkbox>
          </li>
        }
      </ul>
    </span>
  </section>
}
